import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroAuth } from './getExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroAuth';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroBasicInfo } from './getExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroContent } from './getExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroContent';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMedia } from './getExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMedia';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroSource } from './getExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroSource';

export type GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezero = {
  /** 인증 컨텍스트 정보 */
  auth?: GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroAuth;
  basicInfo?: GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroBasicInfo;
  /** 뉴스 내용 정보 */
  content?: GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroContent;
  /** 미디어 정보 */
  media?: GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMedia;
  /** 뉴스 출처 정보 */
  source?: GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroSource;
};
